import View from 'view/view'
import Router from 'service/router'
import experiment from 'service/experiment'
import { localTimezoneFormatHumanDateTime } from 'service/date/format'

import sayHiTemplate from 'component/header/template/say_hi_list_item.tmpl'
import MicroUserView from 'component/user/micro_user'

const TwinkleResultView = View.extend({
    tagName: 'li',
    className: 'headerFlyoutList__item',
    template: sayHiTemplate,

    _renderUser() {
        return this.initSubview(MicroUserView, {
            el: this.$('.js-twinkle-user'),
            model: this.model.getEmbedded('user'),
            size: 'xsmall',
        }).render()
    },

    render() {
        this.$el.html(
            this.template({
                twinkle: this.model.toJSON(),
                createdOn: localTimezoneFormatHumanDateTime(this.model.get('createdOn')),
                link: {
                    twinkle: Router.path('spa_say_hi_index', null, {
                        query: { ref: 'he_stw' },
                    }),
                },
            })
        )

        this._renderUser()

        return this
    },
})

export default TwinkleResultView
